
import { TestResponse, RecruitmentStatus, AIFeedback, QuestionResponse } from "@/types/test-response";
import { Question as ResponseQuestion } from "@/types/test-response";

export const transformTestResponse = (response: any, testId: string, testTitle?: string): TestResponse => {
  // Ensure test.questions exists and is an array before mapping
  const testQuestions = (response.test?.questions && Array.isArray(response.test.questions))
    ? response.test.questions.map((q: any) => ({
        id: q.id,
        created_at: new Date().toISOString(),
        test_id: testId,
        question_type: q.question_type,
        content: q.content,
        marks: q.marks,
        order: q.order,
        time_limit: q.time_limit,
        skill: q.skill,
        difficulty: q.difficulty,
        markscheme: q.markscheme
      }) as ResponseQuestion)
    : [];

  const transformedResponse: TestResponse = {
    id: response.id,
    created_at: response.created_at,
    test_id: response.test_id,
    candidate_id: response.candidate_id,
    status: response.status,
    started_at: response.started_at,
    completed_at: response.completed_at,
    score: response.score,
    total_ai_score: response.total_ai_score || 0,
    scores_confirmed: response.scores_confirmed,
    recruitment_status: (response.recruitment_status || "pending") as RecruitmentStatus,
    recruitment_notes: response.recruitment_notes,
    recruitment_updated_at: response.recruitment_updated_at || response.created_at,
    integrity_score: response.integrity_score,
    test: {
      id: response.test?.id || testId || '',
      title: response.test?.title || testTitle || "Test",
      questions: testQuestions,
    },
    candidate: {
      full_name: response.candidate?.full_name || "",
      email: response.candidate?.email || "",
      avatar_url: response.candidate?.avatar_url,
      phone_number: response.candidate?.phone_number,
      cv_url: response.candidate?.cv_url,
      location: response.candidate?.location,
    },
    question_responses: response.question_responses.map(
      (qr: any): QuestionResponse => {
        const transformedAIFeedback: AIFeedback | null = qr.ai_feedback
          ? {
              score: qr.ai_feedback.score || 0,
              overall_feedback: qr.ai_feedback.overall_feedback || "",
              strengths: qr.ai_feedback.strengths || [],
              improvements: qr.ai_feedback.improvements || [],
              criteria_scores: qr.ai_feedback.criteria_scores || {},
              review_points: qr.ai_feedback.review_points || {},
              comparative_analysis: qr.ai_feedback.comparative_analysis || undefined,
              learning_resources: qr.ai_feedback.learning_resources || undefined,
            }
          : null;

        return {
          ...qr,
          ai_feedback: transformedAIFeedback,
          evaluation_status: qr.evaluation_status || "pending",
          transcription_status: qr.transcription_status || undefined,
          audio_url: qr.audio_url || null,
        };
      }
    ),
  };
  
  return transformedResponse;
};

export const calculateAIScore = (response: TestResponse): number => {
  return response.total_ai_score;
};

export const sortResponsesByAIScore = (responses: TestResponse[], ascending: boolean = false): TestResponse[] => {
  return [...responses].sort((a, b) => {
    const scoreA = a.total_ai_score || 0;
    const scoreB = b.total_ai_score || 0;
    return ascending ? scoreA - scoreB : scoreB - scoreA;
  });
};
